export const toLocalDatetime = (isoDate: string) => {
  const date = new Date(isoDate);
  const pad = (n: number) => String(n).padStart(2, "0");

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const toCustomLocalTimestamp = (isoDate: string | Date): string => {
  const date = new Date(isoDate);

  const pad = (n: number, size = 2) => String(n).padStart(size, "0");

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());
  const millis = pad(date.getMilliseconds(), 3);

  // Get timezone offset in minutes and convert to ±HHMM
  const tzOffsetMin = -date.getTimezoneOffset(); // inverted because JS returns offset from UTC
  const tzSign = tzOffsetMin >= 0 ? "+" : "-";
  const tzHours = pad(Math.floor(Math.abs(tzOffsetMin) / 60));
  const tzMinutes = pad(Math.abs(tzOffsetMin) % 60);

  const tzString = `${tzSign}${tzHours}${tzMinutes}`;

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${millis} ${tzString}`;
};
